import Constants from "expo-constants";

export const REACT_APP_API_ROOT = Constants.expoConfig?.extra?.apiRoot || "";
export const REACT_APP_API_ENDPOINT = `${REACT_APP_API_ROOT}/api`;
export const REACT_APP_ORGANIZATION_ID =
  Constants.expoConfig?.extra?.organizationId || "";
export const REACT_APP_FRONTEND =
  Constants.expoConfig?.extra?.frontApp || "http://localhost:19006";
export const SPECIFIC_THEME = Constants.expoConfig?.extra?.specificTheme || "";
